var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.836.137A1.031 1.031 0 0 0 8.74.183L4.127 4.086H.507a.34.34 0 0 0-.34.34v6.468a.339.339 0 0 0 .34.34l3.612-.001 4.61 4.235c.017.016.036.03.055.04a1.04 1.04 0 0 0 1.052.016c.34-.192.543-.543.543-.938V1.076c0-.396-.203-.747-.543-.94zm-.138 14.449a.39.39 0 0 1-.197.345.357.357 0 0 1-.34.009l-4.569-4.197V9.192a.34.34 0 1 0-.68 0v1.36l-3.065.002V4.766h3.064v1.362a.34.34 0 1 0 .681 0V4.584L9.155.724a.356.356 0 0 1 .346.006.39.39 0 0 1 .197.345v13.51zm1.797-11.338a.34.34 0 0 0-.189.654 3.931 3.931 0 0 1 2.827 3.758 3.931 3.931 0 0 1-2.827 3.759.34.34 0 0 0 .189.654 4.616 4.616 0 0 0 3.319-4.413 4.616 4.616 0 0 0-3.32-4.412z",
    fill: "#767B85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSound);
export default __webpack_public_path__ + "static/media/sound.cd65f9315a31ba2f0957962804a6b0d1.svg";
export { ForwardRef as ReactComponent };